import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.0744 5.38567L22 2.49999V18.0744L15 22.1577L8.92563 18.6143L2 21.5V5.92562L9 1.84229L15.0744 5.38567ZM7.5 7.5C6.5335 7.5 5.75 8.2835 5.75 9.25C5.75 10.2165 6.5335 11 7.5 11C8.4665 11 9.25 10.2165 9.25 9.25C9.25 8.2835 8.4665 7.5 7.5 7.5ZM14 8.5C13.0335 8.5 12.25 9.2835 12.25 10.25C12.25 11.2165 13.0335 12 14 12C14.9665 12 15.75 11.2165 15.75 10.25C15.75 9.2835 14.9665 8.5 14 8.5ZM10 12C9.0335 12 8.25 12.7835 8.25 13.75C8.25 14.7165 9.0335 15.5 10 15.5C10.9665 15.5 11.75 14.7165 11.75 13.75C11.75 12.7835 10.9665 12 10 12ZM16.5 13C15.5335 13 14.75 13.7835 14.75 14.75C14.75 15.7165 15.5335 16.5 16.5 16.5C17.4665 16.5 18.25 15.7165 18.25 14.75C18.25 13.7835 17.4665 13 16.5 13Z"}}]};

const MapBubbleFilled = Vue.extend<IconProps>({
  name: 'MapBubbleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-bubble-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapBubbleFilled;
